module.exports = __webpack_public_path__ + "img/DW365-155.d330eb63.jpg";